var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['TkDownArrow', `-${_vm.size}`]})
}
var staticRenderFns = []

export { render, staticRenderFns }